import dayjs from 'dayjs';
import {Icon, Layout, Menu, Popup, Spacer, Text} from '@di-nxt/components';
import {IconNames} from '@di-nxt/components/src/components/icons/types';
import React from 'react';
import {getHumanizedDiff, useScheduleDataContext} from '../../services';
import {AbsenceProps} from './types';
import {
  useAddOrEditAbsenceTask,
  useDeleteAbsenceTask,
} from '../../scenes/modals/absence';
import assert from 'assert-ts';

export const AbsenceCaption: React.FC<AbsenceProps> = ({absenceInfo}) => {
  // Handler for editing an absence
  const editAbsence = useAddOrEditAbsenceTask(
    assert(absenceInfo.absence.teamId, 'Missing team id on absence'),
    absenceInfo.absence,
    absenceInfo.absenceType,
  );

  // Handler for deleting absences
  const deleteAbsence = useDeleteAbsenceTask(absenceInfo.absence);

  // Context
  const context = useScheduleDataContext();

  return (
    <Popup
      absolute
      trigger={
        <Layout
          vertical
          height={'100%'}
          justify="center"
          paddingHorizontal="6"
          paddingVertical="1">
          <Layout horizontal>
            {absenceInfo && absenceInfo.absenceType && (
              <>
                {absenceInfo && (
                  <>
                    {' '}
                    <Icon
                      name={absenceInfo.absenceType.iconName as IconNames}
                      size="16"
                    />
                    <Spacer width="6" />
                  </>
                )}
                <Text nowrap variant="inline_12_emphasis">
                  {absenceInfo?.absenceType.name}
                  {context.calendarType !== 'month' && (
                    <Text nowrap>
                      {absenceInfo.absence.fromDate &&
                      absenceInfo.absence.toDate
                        ? ` ${getHumanizedDiff(
                            absenceInfo.absence.fromDate,
                            dayjs(absenceInfo.absence.toDate).add(1, 'day'),
                          )} -> ${dayjs(absenceInfo.absence.toDate)
                            .add(1, 'day')
                            .subtract(1, 'day')
                            .format('LL')}`
                        : ''}
                    </Text>
                  )}
                </Text>
              </>
            )}
          </Layout>
        </Layout>
      }>
      {closePopup => (
        <Menu
          items={['Edit', 'Delete']}
          icons={['edit', 'remove']}
          onChange={(index: number) => {
            closePopup();
            switch (index) {
              case 0:
                editAbsence();
                break;
              case 1:
                deleteAbsence();
                break;
            }
          }}
        />
      )}
    </Popup>
  );
};
